<template>
  <div>
    <div class="bottom-line">
      <img :src="path+('bottom-line.png')">
    </div>
    <!--before-test-->
    <div class="before-test-area">
      <div class="top-ribbon">
        <div class="ribbon-bg">
          <div class="left-box">
            <div class="icon-area">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="29" viewBox="0 0 30 29" fill="none">
                <path d="M15.5006 0.408436L18.5363 10.1975L29.1127 10.3367C29.6394 10.3367 29.8335 11.0329 29.3969 11.3184L20.7264 16.9649L24.2265 27.3666C24.3997 27.8748 23.8037 28.2856 23.3879 27.9514L15.0016 21.1422L6.61529 27.9514C6.19944 28.2856 5.61032 27.8748 5.77666 27.3666L9.27672 16.9649L0.606277 11.3184C0.162705 11.0329 0.363695 10.3437 0.890437 10.3367L11.4669 10.1975L14.5025 0.408436C14.655 -0.0928512 15.362 -0.0928512 15.5145 0.408436H15.5006Z" fill="white"/>
              </svg>
            </div>
            <div class="titlebox">
              你是否有配戴移動式假牙？
            </div>
          </div>
          <svg class="arright" xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
            <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#0089D3"/>
          </svg>
        </div>
      </div>
      <div class="card-kv" id="rd-card">
        <div class="left-card">
          <div class="img-area"></div>
        </div>
        <div class="right-card">
          <div class="img-area"></div>
        </div>
      </div>
      <div class="select-are" id="rd-select-area">
        <div class="seltitle">
          請選擇
        </div>
        <div class="btn-area">
          <button class="no" v-on:click="selectAnswer('mouth-test', false)">
            <svg width="36" height="19" viewBox="0 0 36 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.0445 18.336C11.4125 18.336 10.6205 17.448 9.99653 16.272C8.82053 14.064 5.67653 8.448 4.30853 5.28L4.16453 5.328C4.33253 6.168 4.30853 7.344 4.30853 8.184V16.368C4.30853 17.64 3.73253 18.36 2.60453 18.36C1.40453 18.36 0.756531 17.664 0.756531 16.368V2.784C0.756531 1.08 1.54853 0.0479994 3.15653 0.0479994C4.71653 0.0479994 5.48453 0.839999 6.34853 2.568C7.81253 5.52 10.6685 10.632 11.8925 13.176L12.0365 13.128C11.8925 12.336 11.8925 11.28 11.8925 10.44V2.04C11.8925 0.767999 12.4925 0.0479994 13.6925 0.0479994C14.8445 0.0479994 15.4205 0.743999 15.4205 2.04V15.6C15.4205 17.376 14.7485 18.336 13.0445 18.336ZM26.7992 18.36C21.7832 18.36 18.6152 14.904 18.7832 8.952C18.9272 3.48 22.0232 0.0239997 26.9912 0.0239997C32.0072 0.0239997 35.1032 3.552 35.1032 8.952C35.1032 14.928 32.1752 18.36 26.7992 18.36ZM26.8952 15.576C29.5112 15.576 30.8312 13.488 30.8312 9.192C30.8312 4.992 29.4392 2.784 26.8952 2.784C24.3752 2.784 23.0552 4.944 23.0552 9.192C23.0552 13.488 24.3752 15.576 26.8952 15.576Z" fill="#0089D3"/>
            </svg>
          </button>
          <button class="yes" v-on:click="selectAnswer('dentures-test', true)">
            <svg width="44" height="20" viewBox="0 0 44 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.81116 19.36C6.49116 19.36 5.74716 18.64 5.74716 17.272V11.512C4.85916 9.928 2.09916 5.656 1.06716 3.856C0.467156 2.8 0.659156 1.912 1.76316 1.312C2.79516 0.759999 3.70716 1.072 4.33116 2.176L6.29916 5.584C6.82716 6.52 7.54716 7.696 7.93116 8.488H8.09916C8.50716 7.696 9.17916 6.448 9.68316 5.536L11.4832 2.224C12.0832 1.096 12.8512 0.759999 13.9312 1.288C14.9632 1.792 15.2512 2.68 14.6752 3.712C13.2352 6.28 11.5072 8.944 9.87516 11.488V17.272C9.87516 18.64 9.13116 19.36 7.81116 19.36ZM28.94 17.632C28.94 18.52 28.484 19 27.62 19H19.748C18.476 19 17.756 18.304 17.756 16.984V3.376C17.756 2.104 18.452 1.384 19.748 1.384H27.5C28.34 1.384 28.82 1.864 28.82 2.752C28.82 3.64 28.364 4.12 27.5 4.12H22.1C21.98 4.12 21.884 4.192 21.884 4.336V8.536H26.804C27.62 8.536 28.124 9.016 28.124 9.904C28.124 10.768 27.644 11.272 26.804 11.272H21.884V16.048C21.884 16.168 21.956 16.264 22.1 16.264H27.62C28.46 16.264 28.94 16.72 28.94 17.632ZM31.4763 15.232C31.9563 14.584 32.8203 14.464 33.4683 14.968C34.4523 15.736 35.5323 16.48 37.1883 16.48C38.6523 16.48 39.5403 15.856 39.5643 14.704C39.5883 13.768 39.2523 12.808 36.4683 11.368C32.8683 9.472 31.3323 8.008 31.3323 5.536C31.3323 2.8 33.8043 1.024 37.6683 1.024C40.0203 1.024 41.8683 1.96 42.6363 2.608C43.3083 3.184 43.4763 3.976 43.0203 4.672C42.5163 5.416 41.5083 5.56 40.7883 4.984C40.1163 4.456 39.0603 3.856 37.6443 3.88C36.3243 3.904 35.5563 4.432 35.5563 5.248C35.5563 6.16 35.8923 6.976 38.7003 8.416C42.3243 10.312 43.8363 11.824 43.8363 14.224C43.8363 17.44 41.4123 19.36 37.4043 19.36C34.6443 19.36 32.6763 18.448 31.6923 17.464C31.0443 16.816 30.9723 15.928 31.4763 15.232Z" fill="#00A64C"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import {gsap} from "gsap";

  export default {
    props: ["path"],
    name:"FirstTest",
    mounted(){
      gsap.to('.before-test-area',{opacity:1, duration:.5})
    },
    methods: {
      selectAnswer(page, direct){
        let _this = this
        let centerWidth = document.getElementById('rd-card').clientWidth/4;
        let t1 = gsap.timeline()
        // 往右
        if(direct){

            t1.to('#rd-select-area',{duration:.5, opacity:0,visibility:'hidden'})
                .to('.left-card',{duration:.5, x:-300})
                .to('.right-card',{duration:.5, marginRight:'-28%',top:'0%',scale:1.4,marginTop:'15%', rotate:0,borderWidth: 1,borderColor:'#00A64C',borderStyle:'solid'},'<')
                .to('.before-test-area',{opacity:0, delay:.5, duration:.5, onComplete:function () {
                        _this.$emit('switch-component', page)
                    }})
        }
        // 往左
        else{

            t1.to('#rd-select-area',{duration:.5, opacity:0,visibility:'hidden'})
                .to('.right-card',{duration:.5, x:300})
                .to('.left-card',{duration:.5, marginLeft:'-28%',marginTop:'10%',borderWidth: 1,borderColor:'#0089D3',borderStyle:'solid', scale:1.4, rotate:0},'<')
                .to('.before-test-area',{opacity:0, delay:.5, duration:.5, onComplete:function () {
                        _this.$emit('switch-component', page)
                    }})
        }
      }
    }
  }
</script>

